import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getSelectedProductPath,
    getSession,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductState, getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { getComputedVariantProduct } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import setSelectedImageIndex from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/SetSelectedImageIndex";
import { getSelectedImage } from "@insite/client-framework/Store/Pages/ProductDetails/ProductDetailsSelectors";
import { ImageModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductPrimaryImage, { ProductPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import Button, { ButtonIcon, ButtonProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Img from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CarosulArrow from "@tIntermatic/Icons/CarosulArrow";
import ProductImageCarousel, {
    ProductImageCarouselStyles,
} from "@tIntermatic/Overrides/Components/ProductImageCarousel";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => {
    const location = getLocation(state);
    const productPath =
        getSelectedProductPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    const productState = getProductStateByPath(state, productPath);
    const variantProductState = getProductState(state, state.pages.productDetails.selectedProductId);
    const computedVariantProduct = getComputedVariantProduct(productState, variantProductState);

    return {
        selectedImage: getSelectedImage(state, ownProps.product),
        selectedImageIndex: state.pages.productDetails.selectedImageIndex,
        productState: computedVariantProduct,
    };
};

const mapDispatchToProps = {
    setSelectedImageIndex,
};

export interface ProductDetailsPrimaryImageStyles {
    /**
     * @deprecated Use primaryImage styles instead.
     */
    centeringWrapper?: InjectableCss;
    hiddenWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    image?: LazyImageProps;

    primaryImage?: ProductPrimaryImageStyles;
    fullPrimaryImageModal?: ModalPresentationProps;
    fullPrimaryImage?: ProductPrimaryImageStyles;
    imageCarousel?: ProductImageCarouselStyles;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonProps;
    mainContainer?: InjectableCss;
    spinnerContainer?: InjectableCss;
}

export const primaryImageStyles: ProductDetailsPrimaryImageStyles = {
    // fullPrimaryImageModal: {
    //     cssOverrides: {
    //         scrim: css`
    //             height: 100% !important;
    //             overflow: auto;
    //             position: absolute !important;
    //             touch-action: auto;
    //         `,
    //         modalContainer: css`
    //             width: auto;
    //             > div {
    //                 @media all and (max-width: 768px) and (min-width: 0px) {
    //                     min-width: 100%;
    //                 }
    //                 @media all and (max-width: 1024px) and (min-width: 768px) {
    //                     min-width: 80%;
    //                 }
    //             }
    //         `,
    //         modalBody: css`
    //             width: auto;
    //             max-width: initial;
    //             max-height: initial !important;
    //             height: 100vh !important;
    //             box-shadow: 0 0 10px 0 rgb(0 0 0 / 0.15) !important;
    //             border: 1px solid #e5e5e5;
    //             background-color: #fff;
    //         `,
    //         modalTitle: css`
    //             border-bottom: none;
    //             padding: 10px 10px 0;
    //         `,
    //         modalContent: css`
    //             text-align: center;
    //             display: flex;
    //             flex-direction: column;
    //             height: 90vh;
    //         `,
    //         titleButton: css`
    //             color: #363636 !important;
    //             border: none;
    //             padding: 0;
    //             > span {
    //                 color: #363636 !important;
    //                 height: 100%;
    //                 width: 100%;
    //                 > svg {
    //                     height: 38px;
    //                     width: 38px;
    //                     stroke-width: 1;
    //                     stroke: #363636;
    //                 }
    //             }
    //             &:hover {
    //                 background: none;
    //             }
    //         `,
    //     },
    // },
    fullPrimaryImage: {
        image: {
            css: css`
                img {
                    width: auto;
                    max-height: 100%;
                    min-height: 0px !important;
                }
            `,
        },
    },
    prevArrowGridItem: {
        width: 1,
        align: "middle",
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            &:hover {
                span[class^="IconWrapper"] {
                    svg {
                        #Product-Detail_Default {
                            stroke: #006bc0 !important;
                        }
                    }
                }
            }
        `,
    },

    nextArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-start;
        `,
    },
    nextArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            &:hover {
                span[class^="IconWrapper"] {
                    svg {
                        #Product-Detail_Default {
                            stroke: #006bc0 !important;
                        }
                    }
                }
            }
        `,
    },

    mainContainer: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: flex-start;
            @media all and (max-width: 992px) and (min-width: 0px) {
                justify-content: center;
            }
            > div:nth-child(2) {
                min-width: 94%;
            }
        `,
    },
    spinnerContainer: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
};

const styles = primaryImageStyles;

const ProductDetailsPrimaryImage = ({
    product,
    selectedImage,
    selectedImageIndex,
    setSelectedImageIndex,
    productState,
}: Props) => {
    const [fullPrimaryImageModalIsOpen, setFullImageModalIsOpen] = useState(false);
    const imageClickHandler = () => {
        setFullImageModalIsOpen(!fullPrimaryImageModalIsOpen);
    };
    const selectImageHandler = (index: number) => {
        setSelectedImageIndex({ index });
    };
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        if (loading) {
            setTimeout(() => {
                setLoading(false);
            }, 1800);
        }
    }, [loading]);

    if (!product) {
        return null;
    }
    const image =
        selectedImage ??
        ({
            id: product.id,
            imageAltText: product.imageAltText,
            imageType: "Static",
            largeImagePath: product.largeImagePath,
            mediumImagePath: product.mediumImagePath,
            smallImagePath: product.smallImagePath,
        } as ImageModel);

    const path = image.mediumImagePath || image.largeImagePath;
    if (!path) {
        return null;
    }
    const imagesLength = product.images ? product.images.length : 0;
    let carouelImagesLength = 0;
    if (product.images) {
        carouelImagesLength = product.images.length > 4 ? 4 : product?.images?.length;
    }

    if (loading) {
        return (
            <StyledWrapper {...styles.spinnerContainer}>
                <LoadingSpinner {...styles.spinner} />
            </StyledWrapper>
        );
    }

    return (
        <>
            <StyledWrapper {...styles.mainContainer}>
                {imagesLength > 1 && (
                    <StyledWrapper {...styles.prevArrowGridItem}>
                        <Button
                            {...styles.prevArrowButton}
                            onClick={() =>
                                selectImageHandler(
                                    selectedImageIndex > 0 ? selectedImageIndex - 1 : carouelImagesLength - 1,
                                )
                            }
                        >
                            <ButtonIcon
                                src={CarosulArrow}
                                css={css`
                                    transform: rotate(180deg);
                                `}
                            />
                        </Button>
                    </StyledWrapper>
                )}
                <ProductPrimaryImage
                    product={product}
                    image={image}
                    onClick={imageClickHandler}
                    extendedStyles={styles.primaryImage}
                />
                {imagesLength > 1 && (
                    <StyledWrapper {...styles.nextArrowGridItem}>
                        <Button
                            {...styles.nextArrowButton}
                            onClick={() =>
                                selectImageHandler(
                                    selectedImageIndex < carouelImagesLength - 1 ? selectedImageIndex + 1 : 0,
                                )
                            }
                        >
                            <ButtonIcon src={CarosulArrow} />
                        </Button>
                    </StyledWrapper>
                )}
            </StyledWrapper>
            {fullPrimaryImageModalIsOpen && product.images && product.images.length > 1 && (
                <ProductImageCarousel
                    selectedIndex={selectedImageIndex}
                    onSelectImage={selectImageHandler}
                    extendedStyles={styles.imageCarousel}
                    onImageClick={imageClickHandler}
                    fullPrimaryImageModalIsOpen={fullPrimaryImageModalIsOpen}
                />
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsPrimaryImage)),
    definition: {
        displayName: "Primary Image",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
